<template>
  <div class="inner-page playback-record-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="playback-record-main" slot="default">
        <div class="banner">
          <div class="banner-content">
            <a-avatar class="login-avatar" :src="userInfo.avatar || require('../assets/images/common/avatar.png')"></a-avatar>
            <span class="login-name">{{`${userNick}, ${helloMessage}`}}</span>
          </div>
        </div>
        <div class="playback-record-bg">
          <breadcrumb :navList="false"></breadcrumb>
          <div class="content">
            <div class="content--header">
                <div class="course-list-title">
                  <span class="title">播放记录</span>
                </div>
            </div>
            <div class="course-wrap" v-if="courseList.length">
              <div class="course-list">
                <div class="item" v-for="(item, index) in courseList" :key="index">
                  <div class="item-img" @click="goTo('/coursePlayer', item.id)">
                    <img :src="`${item.img}`">
                  </div>
                  <div class="course-type-tag">{{item.typeName}}</div>
                  <div class="item-text">
                    <div class="title" @click="goTo('/coursePlayer', item.id)">
                      <div>
                        <div class="title-img" v-if="item.isNew">
                          <img src="../assets/images/index/new_tag@1x.png">
                        </div>
                        <span>{{item.title}}</span>
                      </div>

                      <h6>{{item.date}}</h6>
                    </div>
                    <div class="videoTime">
                      <div class="left">
                        <div class="time-img">
                          <img src="../assets/images/index/video@1x.png">
                        </div>
                        <span>{{item.duration | transformSecond}}分钟</span>
                      </div>
                      <div class="right" v-if="item.watched_time && item.duration">
                        <span class="watched" v-if="item.watched_time >= item.duration">已看完</span>
                        <span class="watching" v-else>
                          已观看<span>{{item.watched_time | transformSecond}}</span>分钟
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="watchedProgress" v-if="item.watched_time" :style="{width:`${item.watched_time / item.duration * 100}%`}"></div>
                </div>
              </div>
              <pagination :total="total" @pageChange="onPageChange" @pageSizeChange="onPageSizeChange" :pageSizeOptions="pageSizeOptions"></pagination>
            </div>
            <empty v-else />
          </div>
		   <breadcrumb :navList="navList"></breadcrumb>
        </div>
      </div>
      </a-spin>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import Empty from '../components/empty/empty.vue'
import Pagination from '../components/pagination/pagination.vue'
import { course } from '@/api'
import certificateManagement from '@/api/certificate-management'

export default {
  name: 'playbackRecord',
  components: { HeaderRight, Breadcrumb, Pagination, Empty },
  data () {
    return {
      navList: [
        {
          text: '返回首页'
        },
        {
          text: '播放记录'
        }
      ],
      userInfo: {
        userName: '青浦实验小学四（1）班',
        avatar: '',
        nick: ''
      },
      courseList: [],
      helloMessage: '中午好',
      pageSizeOptions: ['12', '24', '36', '48', '60'],
      total: 100,
      pageSize: 12,
      isLoading: false
    }
  },
  filters: {
    transformSecond (second) {
      return Math.ceil(second / 60)
    }
  },
  computed: {
    userNick() {
      let { nick, userName } = this.userInfo
      if (nick === undefined || nick === '' || nick === null) {
        return userName
      }
      return nick
    }
  },
  created () {
    this.getCourseRecords()
  },
  mounted () {
    this.userInfo = certificateManagement._readUserInfo()
    this.helloMessage = this.getTimeState()
  },
  methods: {
    onPageChange ({pageNumber}) {
      let params = {
        page: pageNumber,
        pageSize: this.pageSize
      }
      this.getCourseRecords(params)
    },

    onPageSizeChange ({current, pageSize}) {
      let params = {
        page: current,
        pageSize: pageSize
      }
      this.pageSize = pageSize
      this.getCourseRecords(params)
    },

    getCourseRecords () {
      this.isLoading = true
      course.watchedRecordList().then(res => {
        let { data: result, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        let { data, total } = result || {}
        this.courseList = data
        this.total = total
      }).catch((res) => {
        this.$message.error(JSON.stringify(res))
      }).finally(() => {
        this.isLoading = false
      })
    },
    goTo (path, id) {
      this.$router.push({path, query: {id}})
    },
    getTimeState(){
      let timeNow = new Date();
      let hours = timeNow.getHours();
      let state= ``;

      if (hours >= 0 && hours <= 10) {
          state = `早上好!`;
      } else if (hours > 10 && hours <= 14) {
          state= `中午好!`;
      } else if (hours > 14 && hours <= 18) {
          state= `下午好!`;
      } else if (hours > 18 && hours <= 24) {
          state= `晚上好!`;
      }
      return state;
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  .playback-record-page{
    .banner{
      width: 1920px;
      height: 240px;
      background-size: 100% 100%;
      .bgByMedia('/playback-record/banner', 'png');
      &-content{
        width: 1430px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        height: 100%;
        .login-avatar{
          width: 66px;
          height: 66px;
          margin-right: 16px;
        }
        .login-name{
          font-family: 'SourceHanSansCN-Medium';
          font-size: 30px;
          color: #fff;
        }
      }
    }
    .playback-record-bg{
      font-family: 'SourceHanSansCN-Medium';
      .bgByMedia('/playback-record/bg', 'png');
      min-height: 1163px;
      width: 1920px;
      background-size: 100% auto;
      background-repeat: no-repeat;
      // background-position: 0 167px;
      .content{
        width: 1430px;
        margin: 0 auto 0;
        border-top: 3px solid @hoverColor;
        padding: 37px 32px 55px 32px;
        background-color: @contentBgColor;
        .course-list-title{
          position: relative;
          &::before{
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            background-color: rgba(206, 35, 35, 0.6);
            border-radius: 50%;
          }
          .title{
            font-size: 22px;
            color: @titleColor;
            position: relative;
            z-index: 3;
          }
        }
        .content--header{
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .course-wrap{
        }
        .course-list{
          display: flex;
          flex-wrap: wrap;
          padding: 0 0 36px 0;
          .item{
            margin: 35px 35px 0 0;
            width: 315px;
            height: 264px;
            background-color: @titleBgColor;
            border-radius: 6px;
            overflow: hidden;
            position: relative;
            &-img{
              img{
                width: 100%;
                height: 144px;
              }
            }
            &-text{
              color: @textColor;
              .title{
                font-size: 14px;
                padding: 13px 15px 15px 15px;
                border-bottom: 1px solid @lineColor; /*no*/
                &-img{
                  img{
                    width: 21px;
                    height: 18px;
                    margin-right: 6px;
                  }
                }
                div{
                  padding-bottom: 10px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  span{
                    flex: 1;
                    .ellipsis();
                  }
                }
                h6{
                  font-size: 12px;
                  color: @dateColor;
                  margin: 0;
                }
              }
              .videoTime{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-right: 15px;
                .left{
                  flex: 1;
                  font-size: 13px;
                  display: flex;
                  align-items: center;
                }
                .time-img{
                  img{
                    width: 42px;
                    height: 42px;
                  }
                }
                .right{
                  font-size: 12px;
                  color: @textColor;
                  .watched{
                    color: @watched;
                  }
                  .watching{
                    span{
                      color: @hoverColor;
                      padding: 0 4px;
                    }
                  }
                }
              }
            }
            .watchedProgress{
              height: 4px;
              background-color: @hoverColor;
              position: absolute;
              bottom: 0px; /*no*/
            }
            .course-type-tag{
              position: absolute;
              top: 15px;
              left: 0;
              background-color: @hoverColor;
              color: #fff;
              font-size: 12px;
              max-width: 72px;
              padding: 0 6px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              border-top-right-radius: 3px;
              border-bottom-right-radius: 3px;
              .text-over()
            }
          }
          .item:nth-child(4n+0) {
            margin-right: 0;
          }
          .item:nth-child(-n+4) {
            margin-top: 25px;
          }
        }
      }
    }
  }
</style>
